export default "__VITE_ASSET__b5954dc3__"